export default __webpack_public_path__ + "static/media/layers.2e82b8d3.svg";